
import React, { useState, Fragment } from 'react';
import lodash from 'lodash';

import { DetailInput, DetailSelect, DetailCheckbox } from 'pages/events/components/EventDetailsControls';
import styles from './EventDetailWrapper.scss';
import SingleSelectDetail from './SingleSelectDetail';

function EventDetailWrapper(props) {
    const [view, setView] = useState(props.values.view || '');

    const options = [
        { label: 'Single Select', value: 'SingleSelect'},
        { label: 'Date', value: 'DatePicker'},
        { label: 'Short Text', value: 'ShortText' },
    ];
    const sortedOptions = options.sort((a, b) => (a.value > b.value) ? 1 : -1);

    const showOtherCheckbox = ['SingleSelect'].includes(view);

    function setViewValue(value) {
        setView(value);
        props.onItemChanged(props.values.id, 'view', value);
    }

    const DetailTypeComponent = displayDetailSpecificFields(view);
    return (
        <div className={styles.parent} data-cy="EventDetailWrapper">
            <div>
                <DetailSelect
                    key={`event-detail-${props.values.id}-type-selector`}
                    label={'Detail Type'}
                    placeholder={''}
                    value={view}
                    items={sortedOptions}
                    onSelect={value => setViewValue(value)}
                    data-cy="EventDetailWrapper-DetailSelect"
                />
            </div>
            <div data-cy="EventDetailWrapper-div">
                {
                    showOtherCheckbox
                        ? <DetailCheckbox
                            key={`event-detail-${props.values.id}-other`}
                            id={`event-detail-${props.values.id}-other`}
                            label='Include "Other" as an Option'
                            checked={props.values.enableOtherOption}
                            onChange={
                                checked => props.onItemChanged(
                                    props.values.id,
                                    'enableOtherOption',
                                    checked
                                )
                            }
                        />
                        : <Fragment />
                }
            </div>
            <div>
                <DetailInput
                    key={`event-detail-${props.values.id}-field-title`}
                    title={'Title'}
                    placeholder={'Enter a title for the detail'}
                    required={true}
                    value={props.values.title}
                    isValid={() => !lodash.isEmpty(props.values.title)}
                    onChange={e => props.onItemChanged(props.values.id, 'title', e.target.value.trim())}
                    data-cy="EventDetailWrapper-Title"
                />
            </div>
            <div>
                <DetailInput
                    key={`event-detail-${props.values.id}-field-label`}
                    title={'Label'}
                    placeholder={'Enter a label'}
                    required={true}
                    value={props.values.label}
                    isValid={() => !lodash.isEmpty(props.values.label)}
                    onChange={e => props.onItemChanged(props.values.id, 'label', e.target.value.trim())}
                    data-cy="EventDetailWrapper-Label"
                />
            </div>
            <div>
                <DetailInput
                    key={`event-detail-${props.values.id}-field-description`}
                    title={'Description'}
                    placeholder={'Enter a description'}
                    required={false}
                    value={props.values.description}
                    onChange={e => props.onItemChanged(props.values.id, 'description', e.target.value.trim())}
                    data-cy="EventDetailWrapper-Description"
                />
            </div>

            <DetailTypeComponent id={props.values.id} {...props} />
        </div>
    );
}

function displayDetailSpecificFields(detailType) {
    if (!detailType) {
        return () => <div></div>;
    }

    const detailTypeToComponentMap = {
        'SingleSelect': SingleSelectDetail,
        'DatePicker': () => <div></div>,
        'ShortText': () => <div></div>,
    };

    return detailTypeToComponentMap[detailType];
}

export default EventDetailWrapper;
